"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.articleStore = void 0;
var article_1 = require("./article");
Object.defineProperty(exports, "articleStore", { enumerable: true, get: function () { return article_1.articleStore; } });
//# sourceMappingURL=index.js.map